/**
 * This container exists just for the sake of keeping the router on its own context. It provides
 * the component that will show the routed containers.
 * @ngesdoc component
 * @ngname routerContainer
 * @ngcontainer
 * @ngmodule root
 */
export default {
  template: `
    <router></router>
  `,
};
